import "./App.css";

import Header from "./components/Header";
import Hero from "./components/Hero";
import WhyTube from "./components/WhyTube";
import MemeGallery from "./components/MemeGallery";
import TokenInfo from "./components/TokenInfo";
import JoinFlock from "./components/JoinFlock";
import Footer from "./components/Footer";

function App() {
    return (
        <>
            <Header />

            <Hero />

            <WhyTube />

            <MemeGallery />

            <TokenInfo />

            <JoinFlock />

            <Footer />
        </>
    );
}

export default App;